import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AdminRequest } from '../../services';

const Top = () => {
    const navigate = useNavigate();
    const storage = useSelector((state) => state.storage);
    const { organization } = storage;

    useEffect(() => {
        switch (organization) {
            // 店舗
            case AdminRequest.organization.STORE:
                navigate('/select-menu');
                break;

            // 店舗運営本部 or グロサリー本部
            case AdminRequest.organization.HEADQUARTERS:
            case AdminRequest.organization.GROCERY_HEADQUARTERS:
                navigate('/competitor-master');
                break;

            // IT本部
            case AdminRequest.organization.IT_HEADQUARTERS:
                navigate('/users');
                break;

            // それ以外（つまり未ログイン）
            default:
                navigate('/login');
                break;
        }
    }, [organization, navigate]);

    return null;
};

export default Top;
